// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { Stack, Dropdown, IDropdownOption } from '@fluentui/react';
import { VideoDeviceInfo, AudioDeviceInfo, DeviceManager, LocalAudioStream } from '@azure/communication-calling';
import { localSettingsContainer, dropDownStyles, micStackTokens, mainStackTokens } from './styles/LocalSettings.styles';
import { subscribeToDeviceManager, setMicrophone, updateAudioDevices } from '../core/sideEffects';
import {
    setDeviceManager
} from '../core/actions/devices';
import { Dispatch } from 'redux';
import { State } from '../core/reducers';

export interface LocalSettingsProps {
  deviceManager: DeviceManager;
  videoDeviceList: VideoDeviceInfo[];
  audioDeviceList: AudioDeviceInfo[];
  videoDeviceInfo: VideoDeviceInfo;
  audioDeviceInfo: AudioDeviceInfo;
  setVideoDeviceInfo(device: VideoDeviceInfo): void;
    setAudioDeviceInfo(device: AudioDeviceInfo): void;
    //setLocalAudioStream(device: LocalAudioStream | undefined): void;
    //localAudiostream: LocalAudioStream;
    
}

export default (props: LocalSettingsProps): JSX.Element => {
  const defaultPlaceHolder = 'Select an option';
  const cameraLabel = 'Camera';
    const micLabel = 'Microphone';
    const speakerLabel = 'Speaker';
   
    
  const getDropDownList = (list: Array<VideoDeviceInfo | AudioDeviceInfo>): IDropdownOption[] => {
    return list.map((item) => ({
      val: item,
      key: item.id,
      text: item.name === '' ? item.deviceType : item.name
    }));
  };
  return (
    <Stack className={localSettingsContainer} tokens={mainStackTokens}>
      <Dropdown
        placeholder={defaultPlaceHolder}
        label={cameraLabel}
        options={getDropDownList(props.videoDeviceList)}
        styles={dropDownStyles}
        disabled={props.videoDeviceList.length === 0}
        defaultSelectedKey={props.videoDeviceInfo ? props.videoDeviceInfo.id : ''}
        onChange={(...args): void => {
            const index = args[2] ?? 0;
           
            props.setVideoDeviceInfo(props.videoDeviceList[index]);

            if (window.isCameraOn == "true") {
                window.isCameraOn = "none";
                window.vdInfo = props.videoDeviceList[index];
                const cameraIconId = document.getElementById("cameraIconId") as HTMLButtonElement;
                cameraIconId.click();
               
            }

        }}
      />
      <Stack tokens={micStackTokens}>
        <Dropdown
          placeholder={defaultPlaceHolder}
          label={micLabel}
          styles={dropDownStyles}
          disabled={props.audioDeviceList.length === 0}
          options={getDropDownList(props.audioDeviceList)}
          defaultSelectedKey={props.audioDeviceInfo ? props.audioDeviceInfo.id : ''}
          onChange={(...args): void => {
              const index = args[2] ?? 0;

              console.log("props.deviceManager.selectedMicrophone()");
              console.log(props.deviceManager?.selectedMicrophone);

              (async () => {

                  await props.setAudioDeviceInfo(props.audioDeviceList[index]);

                  await props.deviceManager.selectMicrophone(props.audioDeviceList[index]);

                  window.adInfo = props.audioDeviceList[index];
                  

              })();
              
           
              }
          }
          
        />
          </Stack>
          
         
    </Stack>
  );
};
